import React from 'react';
import './css/PlatformFooter.css';

/**
 * Shared authenticated-page copyright/footer.
 * Keep company name, bilingual wording, link and copyright in ONE place.
 * Mount within the page's content/scroll container, never in a viewport overlay.
 * Registration and Welcome deliberately use their existing separate layouts.
 */
export default function PlatformFooter({ language = 'english', mobile = false, className = '' }) {
  const spanish = language === 'spanish';
  const classes = [
    'tbp-site-footer',
    'tbp-shared-footer',
    mobile ? 'tbp-site-footer--mobile tbp-mobile-legal-footer tbp-unified-footer-v58' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <footer className={classes} aria-label={spanish ? 'Información legal' : 'Legal information'}>
      <a
        className="tbp-shared-footer__company"
        href="https://lenderblockcorp.com/blenderplatform"
        target="_blank"
        rel="noopener noreferrer"
      >
        {spanish
          ? 'The Blender Platform es motorizada por Lenderblock Corporation.'
          : 'The Blender Platform is Powered by Lenderblock Corporation.'}
      </a>
      <span className="tbp-shared-footer__copyright">
        Copyright {new Date().getFullYear()}.{'  '}{spanish ? 'Todos los derechos reservados.' : 'All rights reserved.'}
      </span>
    </footer>
  );
}
